import { Trophy } from "lucide-react";
import { useLang } from "./LangContext";
import { ChapterHead, FadeUp, Soon } from "./Reveal";
import VideoFrame from "./VideoFrame";

export default function Esports() {
  const { t } = useLang();
  const e = t.esports;

  return (
    <section id="espor" className="section esports" data-testid="esports-section">
      <div className="wrap">
        <ChapterHead num={e.num} label={e.label} title={e.title} />
        <div className="esports-grid">
          <div className="esports-statement">
            <FadeUp>
              <p className="big font-display" data-testid="esports-statement">
                {e.statement}
              </p>
            </FadeUp>
            <FadeUp delay={0.08}>
              <p data-testid="esports-p1">{e.p1}</p>
            </FadeUp>
            <FadeUp delay={0.14}>
              <p data-testid="esports-p2">{e.p2}</p>
            </FadeUp>
            <FadeUp delay={0.2}>
              <div className="upcoming-card" data-testid="esports-upcoming-card">
                <div className="icon-chip" aria-hidden="true">
                  <Trophy size={21} strokeWidth={2} />
                </div>
                <h3 className="font-display">{e.upcoming.title}</h3>
                <p>{e.upcoming.text}</p>
                <Soon text={e.upcoming.soon} testid="esports-soon" />
              </div>
            </FadeUp>
          </div>
          <div className="esports-videos" data-testid="esports-videos">
            <FadeUp delay={0.1}>
              <h3 className="font-display esports-videos-title" data-testid="esports-videos-title">{e.videosTitle}</h3>
              <p className="esports-videos-lead" data-testid="esports-videos-lead">{e.videosLead}</p>
            </FadeUp>
            <div className="video-gallery">
              {e.videos.map((video, index) => (
                <FadeUp key={video.id} delay={0.14 + index * 0.08}>
                  <VideoFrame
                    src={video.src}
                    poster={video.poster}
                    badge={video.badge}
                    title={video.title}
                    caption={video.caption}
                    width={video.width}
                    height={video.height}
                    testid={`esports-video-${video.id}`}
                  />
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
